import request from "../api/request";
import utils from "../../utils/index";
import pfile from "@/utils/secretkey/pfile";
import sfile from "@/utils/secretkey/sfile";

var ak = utils.genak();
var ed = utils.re(ak, unescape(pfile)); //秘钥

function decrypt(data){
  if (data?.ak){
    let plaintext = utils.rd(data.ak, unescape(sfile));
    let obj = utils.secret(data.ed, plaintext, true);
    return JSON.parse(obj);
  }else{
    return data
  }
}
function inParameter(data){
  if (data){
    return { sn: ed, jt: utils.secret(data, ak)}
  }else{
    return data
  }
}
//短链列表
export function shortList(data) {
  return request({
    url: "/shortUrl-service/shortUrl/list",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//获取分享模式列表
export function shortModel(data) {
  return request({
    url: "/shortUrl-service/shortUrl/getConfig",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//新建短链
export function addShort(data) {
  return request({
    url: "/shortUrl-service/shortUrl/create",
    method: "post",
    data:inParameter(data),
    isRaw: true, // 表明需要raw格式
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//批量新建短链
export function batchCreateAPI(data) {
  return request({
    url: "/shortUrl-service/shortUrl/batchCreate",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//编辑短链
export function editShort(data) {
  return request({
    url: "/shortUrl-service/shortUrl/edit",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//删除短链
export function delShort(data) {
  return request({
    url: "/shortUrl-service/shortUrl/delete",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
//获取短链详情
export function shortDetail(data) {
  return request({
    url: "/shortUrl-service/shortUrl/detail",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}

//查询url图标标题
export function shortIconInfo(data) {
  return request({
    url: "/shorturl-service/shorturl/queryUrlInfo",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}

//修改分享模式
export function editShareModel(data) {
  return request({
    url: "/shorturl-service/shorturl/modifyShareModel",
    method: "post",
    data:inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {});
}
